import { Resume } from 'packages/types'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { SizeChangeHandler } from 'builder/modules/resumeEditor'
import { HorizontalSlider } from 'builder/components/HorizontalSlider'
import { useTextCustomization } from '../../hooks/useTextCustomization'
import { prettifySize } from '../../../../helpers'
import { useTemplateCustomization } from '../../hooks/useTemplateCustomization'
import { SliderContainer, ValueContainer, Value } from './styles'

type Props = {
  resume: Resume
  handleSizeChange?: SizeChangeHandler
}

export const SIZE = {
  min: 0,
  max: 1,
  step: 0.5,
}

export const SizeSlider = (props: Props) => {
  const { handleSizeChange, resume } = props
  const { supportsNewCustomization } = useTemplateCustomization(resume)
  const { size } = useTextCustomization(resume)
  const { i18n } = useI18n()
  const { isAboveTablet } = useMediaQueries()

  const onSizeChange = (value: number | number[]) => {
    const newValue = Array.isArray(value) ? value[0] : value
    handleSizeChange?.(newValue, size)
  }

  return (
    <TooltipV2
      value={i18n.t(
        'builder.resume_editor.document_customization.sidebar.text_tab.size_customization_warning',
      )}
      width={250}
      multiline={true}
      position="bottom"
      isActive={!supportsNewCustomization}
    >
      <SliderContainer
        data-testid="size-slider-container"
        data-value={size}
        data-value-prettified={prettifySize(size)}
      >
        {!isAboveTablet && (
          <ValueContainer>
            <Value>{prettifySize(0)}</Value>
          </ValueContainer>
        )}
        <HorizontalSlider
          disabled={!supportsNewCustomization || !handleSizeChange}
          defaultValue={0}
          value={size}
          step={SIZE.step}
          min={SIZE.min}
          max={SIZE.max}
          onChange={onSizeChange}
        />
        {!isAboveTablet && (
          <ValueContainer>
            <Value>{prettifySize(1)}</Value>
          </ValueContainer>
        )}
        {isAboveTablet && (
          <ValueContainer>
            <Value>{prettifySize(size)}</Value>
          </ValueContainer>
        )}
      </SliderContainer>
    </TooltipV2>
  )
}
